import React from 'react';
import './upgrade.css';
import {
  PRO_PLAN_AI_REQUEST_LIMIT,
  PRO_PLAN_CODEBASES_INDEXED,
  PRO_PLAN_CODEBASE_CONTEXT_FILE_LIMIT,
} from '../const';

const ProPlanDescription = () => {
  const numRequestsLabel =
    PRO_PLAN_AI_REQUEST_LIMIT === Infinity
      ? 'Unlimited'
      : PRO_PLAN_AI_REQUEST_LIMIT;

  return (
    <div className="upgrade-plan-description">
      For professional engineers to leverage advanced AI. Get everything in
      Free, plus:
      <ul>
        <li>{numRequestsLabel} Warp AI requests per user per month</li>
        <li>Pay-as-you-go AI overages</li>
        <li>
          {PRO_PLAN_CODEBASES_INDEXED} indexed codebases, up to{' '}
          {PRO_PLAN_CODEBASE_CONTEXT_FILE_LIMIT} files / codebase
        </li>
        <li>Unlimited shared Notebooks and Workflows in Warp Drive</li>
        <li>Unlimited real-time session sharing</li>
        <li>Private email support</li>
      </ul>
    </div>
  );
};

export default ProPlanDescription;
